import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=c23b1ca2&scoped=true"
import script from "./InformationBlock.vue?vue&type=script&lang=js"
export * from "./InformationBlock.vue?vue&type=script&lang=js"
import style0 from "./InformationBlock.vue?vue&type=style&index=0&id=c23b1ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23b1ca2",
  null
  
)

export default component.exports